import * as Types from '../../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FirstSignInUpdateUserConsentMutationVariables = Types.Exact<{
  id: Types.Scalars['String'];
  privacyPolicy: Types.Scalars['Boolean'];
  marketing: Types.Scalars['Boolean'];
  whatsappConsent?: Types.InputMaybe<Types.Scalars['Boolean']>;
  softwareTermsOfUse: Types.Scalars['Boolean'];
  uiDefaultArgs: Types.UpsertUiDefaultInput;
}>;


export type FirstSignInUpdateUserConsentMutation = { readonly __typename?: 'Mutation', readonly updateUser: { readonly __typename?: 'User', readonly _id: string, readonly person?: { readonly __typename?: 'UserPerson', readonly whatsappConsent: boolean } | null }, readonly upsertUiDefault: { readonly __typename?: 'UiDefault', readonly id: string, readonly namespace: string, readonly name: string, readonly scope: Types.DefaultScope, readonly value: unknown } };


export const FirstSignInUpdateUserConsentDocument = gql`
    mutation FirstSignInUpdateUserConsent($id: String!, $privacyPolicy: Boolean!, $marketing: Boolean!, $whatsappConsent: Boolean, $softwareTermsOfUse: Boolean!, $uiDefaultArgs: UpsertUiDefaultInput!) {
  updateUser(
    input: {_id: $id, consent: {privacyPolicy: $privacyPolicy, marketing: $marketing, softwareTermsOfUse: $softwareTermsOfUse}, person: {whatsappConsent: $whatsappConsent}}
  ) {
    _id
    person {
      whatsappConsent
    }
  }
  upsertUiDefault(input: $uiDefaultArgs) {
    id
    namespace
    name
    scope
    value
  }
}
    `;
export type FirstSignInUpdateUserConsentMutationFn = Apollo.MutationFunction<FirstSignInUpdateUserConsentMutation, FirstSignInUpdateUserConsentMutationVariables>;

/**
 * __useFirstSignInUpdateUserConsentMutation__
 *
 * To run a mutation, you first call `useFirstSignInUpdateUserConsentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFirstSignInUpdateUserConsentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [firstSignInUpdateUserConsentMutation, { data, loading, error }] = useFirstSignInUpdateUserConsentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      privacyPolicy: // value for 'privacyPolicy'
 *      marketing: // value for 'marketing'
 *      whatsappConsent: // value for 'whatsappConsent'
 *      softwareTermsOfUse: // value for 'softwareTermsOfUse'
 *      uiDefaultArgs: // value for 'uiDefaultArgs'
 *   },
 * });
 */
export function useFirstSignInUpdateUserConsentMutation(baseOptions?: Apollo.MutationHookOptions<FirstSignInUpdateUserConsentMutation, FirstSignInUpdateUserConsentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FirstSignInUpdateUserConsentMutation, FirstSignInUpdateUserConsentMutationVariables>(FirstSignInUpdateUserConsentDocument, options);
      }
export type FirstSignInUpdateUserConsentMutationHookResult = ReturnType<typeof useFirstSignInUpdateUserConsentMutation>;
export type FirstSignInUpdateUserConsentMutationResult = Apollo.MutationResult<FirstSignInUpdateUserConsentMutation>;
export type FirstSignInUpdateUserConsentMutationOptions = Apollo.BaseMutationOptions<FirstSignInUpdateUserConsentMutation, FirstSignInUpdateUserConsentMutationVariables>;